import React, { Component } from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { Modal, Alert } from 'react-bootstrap';
import { PropTypes } from 'prop-types';
import CreateKeyButton from './CreateKeyButton';
import DeleteKeyButton from './DeleteKeyButton';
import LoadingSpinner from './LoadingSpinner';

// CSS
import './Modal.css';
import brandingStyles from '../branding/brandingStyles';

import { namespace } from '../../../config.json';

class ListKeysButtonComponent extends Component {

    constructor() {
        super();
        this.state = {
            showModal: false,
            keys: null,
            UIAccessKeys: [],
            modalErrorAlert: '',
            dataLoaded: false,
        };

        this.openModal = this.openModal.bind(this);
        this.closeModal = this.closeModal.bind(this);
        this.refresh = this.refresh.bind(this);
    }

    // Open react-bootstrap modal
    openModal() {
        this.setState({ showModal: true });
        this.refresh();
    }

    // Clear and retrieve data again
    refresh() {
        this.props.getKeys(this.props.username)
        .then(res => {
            let UIAccessKeys = [];
            if (res.hasOwnProperty('UIAccessKeys')) {
                UIAccessKeys = res.UIAccessKeys;
            }
            this.setState({ keys: res.keys, UIAccessKeys, dataLoaded: true });
        }).catch(message => {
            if (message.status === 401 || message.status === 403) {
                window.location.href =
                    `${namespace}/login/error/${message.status}`;
            } else {
                this.setState({
                    modalErrorAlert: `Unable to process the request as the
                                     server returned an Internal Error.`,
                });
            }
        }
        );
    }

    // Close react-bootstrap modal
    closeModal() {
        this.setState({
            showModal: false,
            keys: null,
            UIAccessKeys: [],
            modalErrorAlert: '',
            dataLoaded: false,
        });
    }

    getKeyRow(key, index) {
        return (
            <tr
              key={key.AccessKeyId}
              style={
                index % 2 === 0
                ? brandingStyles.backgrounds.panelSecondary
                : brandingStyles.backgrounds.panel
              }
            >
                <td data={key.AccessKeyId} className="padding-l-25 bold">
                    {key.AccessKeyId}
                </td>
                <td>
                    <span className="badge" style={{
                        backgroundColor: '#5cb85c',
                    }}>{key.Status}</span>
                </td>
                <td>
                    {key.CreateDate}
                </td>
                <td>
                    <DeleteKeyButton
                      username={this.props.username}
                      userType={this.props.userType}
                      access={key.AccessKeyId}
                      isUiKey={
                          this.state.UIAccessKeys.includes(key.AccessKeyId)
                      }
                      deleteKey={this.props.deleteKey}
                      callback={this.refresh}/>
                </td>
            </tr>
        );
    }

    render() {
        let keysList;

        // Setting keyList
        if (this.state.keys && this.state.keys.length) {
            // Map over the contacts and get an element for each of them
            keysList = this.state.keys.map(
              (key, index) => this.getKeyRow(key, index)
            );
        } else {
            keysList = <tr>
                <td colSpan="4">
                    <Alert bsStyle="info">
                        <i className="fa fa-info-circle"></i>
                         <span>&nbsp;</span>No keys assigned to this
                         &nbsp;{this.props.userType}.
                         Please generate a key using the button above.
                    </Alert>
                </td>
            </tr>;
        }

        // An error has been raised overriding keysList to display error
        if (this.state.modalErrorAlert.length) {
            keysList = <tr>
              <td colSpan="4">
                <Alert bsStyle="danger">
                  {this.state.modalErrorAlert}
                </Alert>
              </td>
          </tr>;
        }

        const table = (
          <table className="table table-striped" id="table">
              <thead>
                  <tr>
                      <th className="padding-l-25">
                          <strong className="name-header">
                            AccessKey
                          </strong>
                      </th>
                      <th>
                          <strong className="name-header">
                            Status
                          </strong>
                      </th>
                      <th>
                          <strong className="name-header">
                            Created on
                          </strong>
                      </th>
                      <th>
                          <strong className="name-header">
                          </strong>
                      </th>
                  </tr>
              </thead>
              <tbody>
                {keysList}
              </tbody>
          </table>
        );

        return (
          <OverlayTrigger
            trigger={['hover', 'focus']}
            placement="top"
            overlay={
              <Tooltip id="userKeysTooltip">
                {this.props.userType.charAt(0).toUpperCase() +
                this.props.userType.slice(1)} Keys
              </Tooltip>
          }>
            <button
              className="btn btn-primary btn-xs"
              style={brandingStyles.buttons.primary}
              onClick={this.openModal}
            >
                <i className="fa fa-key"></i>

                <Modal show={this.state.showModal}
                  onHide={this.closeModal}
                  bsSize="large">
                    <Modal.Header
                      style={brandingStyles.backgrounds.panelHeader}
                    >
                        <Modal.Title
                          style={brandingStyles.backgrounds.panelHeader}
                        >
                            <i
                              className="fa fa-key"
                              style={brandingStyles.mainColor}
                            ></i>
                            <span>&nbsp;</span>
                            Manage access keys
                            <i
                                className="fa fa-times pull-right clickable"
                                style={Object.assign(
                                  { marginTop: '3px' },
                                  brandingStyles.mainColor
                                )}
                                onClick={this.closeModal}
                            ></i>
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body
                      className="padding-0"
                      style={brandingStyles.backgrounds.panel}
                    >
                        <div className="padding-15">
                            <CreateKeyButton
                              username={this.props.username}
                              userType={this.props.userType}
                              createKey={this.props.createKey}
                              callback={this.refresh}/>
                        </div>
                        <div className="table-responsive">
                          {this.state.dataLoaded
                            ? table : <LoadingSpinner />}
                        </div>
                    </Modal.Body>
                    <Modal.Footer style={brandingStyles.backgrounds.panel}>
                        <button
                          className="btn btn-primary"
                          style={brandingStyles.buttons.primary}
                          onClick={this.closeModal}>
                          Close
                        </button>
                    </Modal.Footer>
                </Modal>
            </button>
          </OverlayTrigger>
        );
    }

}

// Username is mandatory for listing operation to work
ListKeysButtonComponent.propTypes = {
    username: PropTypes.string.isRequired,
    userType: PropTypes.string.isRequired,
    getKeys: PropTypes.func.isRequired,
    deleteKey: PropTypes.func.isRequired,
    createKey: PropTypes.func.isRequired,
    callback: PropTypes.func,
};

export default ListKeysButtonComponent;



/** WEBPACK FOOTER **
 ** ./src/components/ListKeysButton.js
 **/